<template lang="pug">
  #contract-chat-confirm
    .d-flex
      b-card.mt-1.flex-grow-1(header-tag="header")
        b-form-text.mx-2.my-2.align-left.text-left.error-message-color(v-for="(error_msg, key) of error_msg_list", :key="key") {{error_msg}}
        contract-chat-confirm-data(v-model="register_data", :error_msg_list="error_msg_list", :contract_type="value.contract_type")
        contract-conditions.mx-3.mb-4(:show-chat="true", :show-individual-terms="false")
        b-button.float-left.ml-5.my-3(pill, variant="outline-secondary", size="lg", :to="{name: 'ContractChatOrder'}")
          .float-right.search_message.ml-1.font-weight-bold 戻る
          b-icon.float-left.next-icon(icon="arrow-left-circle")
        b-button.order-confirm-button.float-right.mr-5.my-3(pill, variant="outline-success", size="lg", @click="send", :disabled="isLoading")
          span.search_message.mr-1.font-weight-bold 申し込みを確定する
          b-icon.next-icon(icon="arrow-right-circle")
      contract-chat-price(v-model="value")
</template>

<script>
import Api from '@/repositories/api';
import ContractChatConfirmData from "@/components/contractOrder/ContractChatConfirmData";
import ContractConditions from "@/components/ContractConditions";
import ContractChatPrice from "@/components/contractOrder/ContractChatPrice";

const S205ChatContractOrder = Api.get('s205ChatContractOrder');

export default {
  name: "ContractChatConfirm",
  components: {
    ContractConditions,
    ContractChatConfirmData,
    ContractChatPrice
  },
  props: {
    value: {type: Object, required: false},
  },
  data() {
    return {
      error_msg_list: [],

      // 登録用データ
      register_data: {}
    }
  },
  created() {
    // 権限チェックを行う
    this.validateAuthority()

    // propsのvalueを登録用データに変える
    this.initDataChat()

    // 無料お試し版からのデータ移行がある場合
    if (this.value.migration === true) {
      // 移行作業に関するデータ
      let migration = {}

      // 移行作業のデータを作成する
      migration.url       = this.value.migration_url || ""       // URL
      migration.date      = this.value.migration_date || ""      // 作業日付
      migration.time_from = this.value.migration_time_from || "" // 作業時刻（から）
      migration.time_to   = this.value.migration_time_to || ""   // 作業時刻（まで）

      // 登録用データに移行作業に関するデータを追加
      this.register_data.migration = migration
    }
    // 無料お試し版からのデータ移行がない場合
    else {
      // ご利用開始希望日
      this.register_data.preferred_date = this.value.preferred_date || ""
    }

    // お見積番号
    if (this.value.estimate !== null && this.value.estimate !== '') {
      this.register_data.estimate = this.value.estimate
    }

    // 備考
    this.register_data.remarks = this.value.remarks

    // サービス利用約款
    this.register_data.provision = this.value.provision || false
  },
  methods: {
    /**
     * 権限チェックを行う
     */
    validateAuthority() {
      S205ChatContractOrder.view()
        .catch((err) => {
          // httpステータスコードが403の場合（権限エラー）
          if (err.response.status === 403) {
            // アプリケーションエラー画面へ遷移する
            this.$router.push({
              name: 'SupportApplicationError',
              params: {
                // 画面に表示するエラーメッセージ
                error_msg: this.forbidden_message
              }
            })
          }
        })
        .finally(() => {
          // ローディング終了
          this.isLoading = false
        })
    },
    // 登録用データの初期化（Chat）
    initDataChat() {
      // 契約番号
      this.register_data.contract_no = this.value.contract_no

      // ChatLuck
      if (this.value.chat_user !== null) {
        // ユーザ数設定
        this.register_data.chat_user = this.value.chat_user || 0
      }

      // オプションサービス
      if (this.value.option === true) {
        // オプション用オブジェクト初期化
        let option = {}

        // ディスク増設
        if (this.value.disk === true) {
          option.disk = {
            disk_size: this.value.disk_size
          }
        }

        // オプションのデータがある場合
        if (this.isNotEmptyObject(option) === true) {
          // 登録用データにオプションを追加
          this.register_data.option = option
        }
      }

      // セキュリティオプション
      if (this.value.security === true) {
        // セキュリティオプション用オブジェクト初期化
        let security = {}

        // BASIC認証
        if (this.value.basic === true) {
          security.basic = {
            basic_id       : this.value.basic_id,
            basic_password : this.value.basic_password,
            basic_except_ip: this.value.basic_except_ip
          }
        }

        // 接続元IPアドレス制限
        if (this.value.connect_permit === true) {
          security.connect_permit_ip = this.value.connect_permit_ip
        }

        // セキュリティオプションのデータがある場合
        if (this.isNotEmptyObject(security) === true) {
          // 登録用データにセキュリティオプション追加
          this.register_data.security = security
        }
      }

      // 製品以外の情報
      this.register_data.sub_domain = this.value.sub_domain // ご希望サブドメイン名
    },
    send() {
      // エラーメッセージを初期化する
      this.error_msg_list = []

      // 次へボタンをロックする
      this.isLoading = true;

      // お申し込みの登録処理
      S205ChatContractOrder.add(this.register_data)
      // 成功時
      .then(() => {
        // ローカルストレージからプランを削除
        localStorage.removeItem('plan_name')

        // TOPページに移動
        this.$router.push({
          name: "TopPage"
        });
      })
      // 失敗時
      .catch((error) => {
        // 次へボタンをロックを解除する
        this.isLoading = false;

        // 共通のエラー処理
        this.apiError(error, '登録処理', 'ContractNeo')

        // エラー発生時はエラーメッセージを表示する
        if (error.response.data && error.response.data.message) {
          // httpステータスコードが403の場合（権限エラー）
          if (error.response.status === 403) {
            // 画面上部にエラーメッセージを表示する
            this.error_msg_list.push(this.forbidden_message);
          }
          // CakePHP Exception
          else {
            // 画面上部にエラーメッセージを表示する
            this.error_msg_list.push(error.response.data.message);
          }
        }
        else if (error.response.data && error.response.data.error_list) {
          // バリデーションエラー
          // 項目確認のみで入力が無いので個別に表示しない
          for (let messages of error.response.data.error_list) {
            // 画面にエラーメッセージ表示
            this.error_msg_list.push(messages.error_msg)
          }
        }
        else {
          // その他エラー
          this.error_msg_list.push(error)
        }

        // TOP画面までスクロールをする
        this.pageTopScroll()
      })
    }
  }
}
</script>

<style scoped>
.next-icon {
  margin-top: 2px;
}
.image-size {
  width: 200px;
  height: 150px;
}
</style>
